export default "__VITE_ASSET__7TCP658Y__"